import { render, staticRenderFns } from "./VSelectPaginated.vue?vue&type=template&id=87e4d732&"
import script from "./VSelectPaginated.vue?vue&type=script&lang=js&"
export * from "./VSelectPaginated.vue?vue&type=script&lang=js&"
import style0 from "./VSelectPaginated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VLazy,VProgressCircular,VRow,VSelect})
